module.exports = __webpack_public_path__ + "img/icecream.cf158862.png";